// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

editCardModalStyles.expirationMonthGridItem = {
    width: 6,
};

editCardModalStyles.expirationYearGridItem = {
    width: 6,
    css: css`
        align-items: flex-end;
    `,
};

editCardModalStyles.countryGridItem = {
    width: [12, 6, 6, 6, 6],
};

editCardModalStyles.stateGridItem = {
    width: [12, 6, 6, 6, 6],
};

editCardModalStyles.cityGridItem = {
    width: [12, 6, 6, 6, 6],
};

editCardModalStyles.postalCodeGridItem = {
    width: [12, 6, 6, 6, 6],
};

editCardModalStyles.buttonsHidden = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
    `,
};

editCardModalStyles.buttonsContainer = {
    gap: 20,
    css: css`
        & > div {
            justify-content: flex-end;
            button {
                width: 100%;
                white-space: nowrap;
            }
        }
    `,
};

editCardModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        ${xScreen("lte", "xs")} {
            order: 1;
            width: 100%;
            margin-right: 0;
        }
    `,
};

editCardModalStyles.cancelGridItem = {
    width: [12, 3, 2, 2, 2],
    css: css`
        ${xScreen("lte", "xs")} {
            order: 1;
        }
    `,
};

editCardModalStyles.saveGridItem = {
    width: [12, 3, 2, 2, 2],
};
